import type { en } from './en.js';

export const ru: typeof en = {
  app: {
    name: 'Шашки',
  },
  seo: {
    title:
      'Шашки онлайн — русские шашки с другом или с компьютером бесплатно | BN-games',
    description:
      'Играйте в русские шашки бесплатно в браузере — с ботом, с другом онлайн по коду комнаты или вдвоём на одном устройстве. Есть и английские шашки. Без регистрации.',
    social:
      'Шашки в браузере — русские и английские. С другом онлайн или с ботом.',
    h1:
      'Шашки онлайн — русские и английские',
    intro:
      'В шашки играют по всему миру, и почти в каждой стране — по своим правилам. На BN-games два варианта. В русских шашках простая бьёт и назад, дамка «летает» по всей диагонали, а шашка, дошедшая до последнего ряда во время взятия, продолжает бить уже как дамка. В английских шашках (чекерс) дамка ходит на одно поле, а простые бьют только вперёд.\n\nИграйте бесплатно прямо в браузере: с ботом, вдвоём на одном устройстве или онлайн с другом по коду комнаты.',
    rulesTitle:
      'Правила игры в шашки — русские и английские шашки | BN-games',
    rulesDescription:
      'Как играть в шашки: правила русских шашек (летающая дамка, взятие назад, превращение во время боя) и английских шашек — и сразу играть онлайн.',
    rulesH1:
      'Правила игры в шашки',
    playCta:
      'Играть в шашки',
  },
  a11y: {
    canvasLabel: 'Доска для шашек. Стрелки — перемещение фокуса по клеткам, Enter — выбор фигуры или подтверждение хода.',
  },
  narration: {
    subjects: {
      you: 'Вы',
      opponent: 'Соперник',
      white: 'Белые',
      black: 'Чёрные',
    },
    pieces: {
      man: 'шашкой',
      king: 'дамкой',
    },
    move: '{{subject}} сходили {{piece}} с {{from}} на {{to}}.',
    captureOne: '{{subject}} срубили шашку соперника {{piece}} с {{from}}, приземлившись на {{to}}.',
    captureMany: '{{subject}} срубили {{count}} шашек {{piece}} с {{from}}, завершив на {{to}}.',
    promotionTail: 'Шашка прошла в дамки на {{to}}.',
    promotionEndsChain: 'Превращение завершило цепочку.',
    turn: 'Ход — {{subject}}.',
    turnYou: 'Ваш ход.',
    gameOver: 'Победа: {{subject}}.',
    gameOverYou: 'Вы выиграли!',
    gameOverLoss: 'Вы проиграли.',
    gameOverDraw: 'Ничья.',
    cursor: {
      empty: '{{square}}',
      ownMan: '{{square}}, ваша шашка',
      ownKing: '{{square}}, ваша дамка',
      oppMan: '{{square}}, шашка соперника',
      oppKing: '{{square}}, дамка соперника',
      whiteMan: '{{square}}, белая шашка',
      whiteKing: '{{square}}, белая дамка',
      blackMan: '{{square}}, чёрная шашка',
      blackKing: '{{square}}, чёрная дамка',
      validMove: '{{square}}, можно сходить',
      validCapture: '{{square}}, можно срубить',
    },
    selection: {
      man: 'Выбрана шашка на {{square}}.',
      king: 'Выбрана дамка на {{square}}.',
      deselect: 'Выбор снят.',
    },
    chainStep: 'Срублена фигура на {{cap}}. Приземление на {{land}}. Цепочка продолжается.',
  },
  common: {
    back: '← Назад',
    opponent: 'Соперник',
    white: 'Белые',
    black: 'Чёрные',
    cycle: 'нажмите Enter для смены',
  },
  gameOverlay: {
    title: 'Пауза',
    openTooltip: 'Меню паузы',
    settingsLabel: 'Настройки',
    settingsBackLabel: '← Назад',
    settingsViewTitle: 'Настройки',
    restartLabel: 'Сыграть заново',
    restartHintOnline: 'Онлайн: нужно согласие всех. Одно предложение за партию.',
    restartHintAlreadyProposed: 'Вы уже предлагали рестарт в этой партии.',
    restartHintPending: 'Ждём ответа другого игрока…',
    returnToMenuLabel: 'В главное меню',
    returnToMenuConfirmTitle: 'Выйти из партии и вернуться в меню?',
    returnToMenuConfirmYes: 'Да, выйти',
    returnToMenuConfirmNo: 'Остаться',
    giveUpLabel: 'Сдаться',
    giveUpConfirmTitle: 'Точно сдаёшься, трус?',
    giveUpConfirmYes: 'Да, я трус',
    giveUpConfirmNo: 'Продолжу борьбу',
    settingsTabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
      audio: 'Звук',
    },
    discardConfirmTitle: 'Прервать текущую партию?',
    discardConfirmBody: 'Изменение этой настройки завершит текущую игру и начнёт новую.',
    discardConfirmYes: 'Прервать и начать заново',
    discardConfirmNo: 'Отмена',
    close: 'Закрыть',
  },
  auth: {
    signIn: 'Войти',
    signOut: 'Выйти',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Заполните профиль →',
    profile: 'Профиль',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Закрыть',
    invite: {
      message: '{{sender}} приглашает вас в {{game}}',
      moreCount_one: '+{{count}} ещё приглашение',
      moreCount_few: '+{{count}} ещё приглашения',
      moreCount_many: '+{{count}} ещё приглашений',
      moreCount_other: '+{{count}} ещё приглашений',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptAria: 'Принять приглашение от {{sender}} в {{game}}',
      declineAria: 'Отклонить приглашение от {{sender}} в {{game}}',
    },
    dock: {
      pillLabel: 'От {{sender}}',
      pillAria: 'Приглашение от {{sender}} в {{game}} — показать',
      popoverLabel: 'Приглашение',
      close: 'Закрыть приглашение',
      leaveGameTitle: 'Покинуть игру?',
      leaveGameBody: 'Приглашение откроет {{game}}, а текущая партия будет прервана. В онлайн-игре ваше место какое-то время сохраняется — вы сможете вернуться.',
      leaveGameConfirm: 'Выйти и присоединиться',
      leaveGameCancel: 'Остаться',
    },
    friendPicker: {
      button: 'Пригласить друга',
      modalTitle: 'Пригласить друга',
      loading: 'Загрузка друзей…',
      signInPrompt: 'Войдите, чтобы пригласить друга.',
      empty: 'У вас пока нет друзей.',
      findFriends: 'Найти друзей',
      invite: 'Пригласить',
      inviteAria: 'Пригласить {{name}}',
      invited: 'Приглашён',
      invitedAria: '{{name}} приглашён',
      notAccepting: 'Этот игрок сейчас не принимает приглашения',
      retryIn: 'Повторите через {{seconds}} с',
    },
    addOpponent: {
      buttonMany: 'Добавить друзей…',
      modalTitle: 'Добавить друзей',
      add: 'Добавить {{name}} в друзья',
      added: 'Добавлен',
      addedAria: '{{name}} добавлен в друзья',
    },
  },
  mainMenu: {
    quickStart: 'Быстрый старт',
    newGame: 'Новая игра',
    rules: 'Правила',
    settings: 'Настройки',
    history: 'История игр',
    about: 'Об игре',
  },
  preGame: {
    sideLabel: 'Ваш цвет',
    rematchPreview: 'Реванш (вы играете {{side}})',
  },
  playMenu: {
    title: 'Игра',
    vsAi: 'Против бота',
    vsHuman: 'Против человека (локально)',
    createOnline: 'Создать онлайн-игру',
    joinOnline: 'Присоединиться к игре',
    gamesHistory: 'История игр',
    resume: 'Продолжить игру',
    resumeOnline: 'Продолжить онлайн ({{code}})',
    vsAiSession: 'Против бота ({{difficulty}})',
    localMode: 'Локальная игра',
    onlineMode: 'Против {{opponent}}',
    justNow: 'только что',
    minutesAgo: '{{count}} мин назад',
    hoursAgo: '{{count}} ч назад',
    daysAgo: '{{count}} дн назад',
    discardModal: {
      title: 'Отказаться от текущей игры?',
      body: 'Начало новой игры удалит текущую незавершённую партию. Это действие нельзя отменить.',
      keep: 'Оставить игру',
      discard: 'Отказаться',
    },
  },
  settings: {
    title: 'Настройки',
    tabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
      audio: 'Звук',
    },
    rows: {
      playerName: 'Имя игрока',
      sound: 'Звук',
      difficulty: 'Сложность',
      defaultColor: 'Цвет по умолчанию',
      theme: 'Оформление',
      language: 'Язык',
      showValidMoves: 'Показывать возможные ходы',
      variant: 'Вариант',
      afkAssistEnabled: 'Подсказка хода при бездействии',
      afkRemindersEnabled: 'Звук напоминания AFK',
      turnStartSound: 'Звук начала хода',
      showAfkPingButton: 'Показывать кнопку «пинг»',
    },
    difficulties: {
      easy: 'Лёгкий',
      normal: 'Обычный',
      hard: 'Сложный',
      expert: 'Эксперт',
    },
    colors: {
      white: 'Белые',
      black: 'Чёрные',
      random: 'Случайный',
    },
    themes: {
      mahogany: 'Mahogany',
      persian: 'Persian',
      deco: 'Deco',
      monte: 'Monte',
    },
    languages: {
      en: 'English',
      ru: 'Русский',
    },
    variants: {
      russian: 'Советские шашки',
      english: 'Английские шашки',
    },
    on: 'Вкл',
    off: 'Выкл',
    namePrompt: 'Введите ваше имя:',
  },
  about: {
    version: 'Версия {{version}}',
    tech: 'TypeScript + Canvas',
  },
  rules: {
    screenTitle: 'Правила',
    russian: {
      title: 'Советские шашки',
      items: {
        setup: {
          title: 'Расстановка',
          body: 'У каждого игрока 12 шашек на тёмных полях трёх ближних рядов доски 8×8. Первыми ходят белые.',
        },
        menMovement: {
          title: 'Простые',
          body: 'Простая шашка ходит на одно поле по диагонали вперёд на свободное тёмное поле.',
        },
        menCaptures: {
          title: 'Бой простой',
          body: 'Простая бьёт через соседнюю шашку соперника — вперёд или назад — приземляясь на свободное поле за ней. Бой обязателен.',
        },
        kings: {
          title: 'Дамки',
          body: 'Шашка, достигшая последней горизонтали соперника, становится дамкой. Дамка ходит на любое число свободных полей по диагонали в любую сторону.',
        },
        kingCaptures: {
          title: 'Бой дамки',
          body: 'Дамка бьёт, пролетая по диагонали через любое количество пустых полей, перепрыгивает одну шашку соперника и может остановиться на любом свободном поле за ней.',
        },
        chain: {
          title: 'Серия боёв',
          body: 'Если после боя возможен следующий бой с того же поля, он обязателен в этом же ходу. Если возможны несколько вариантов боя, игрок выбирает — правила максимума нет.',
        },
        midJumpPromotion: {
          title: 'Превращение в бою',
          body: 'Простая, попавшая на дамочную горизонталь в середине серии боёв, тут же становится дамкой и продолжает серию как дамка.',
        },
        ending: {
          title: 'Окончание',
          body: 'Победа — взять все шашки соперника или лишить его ходов. Ничья — 15 ходов одних дамок без боя, троекратное повторение позиции или недостаточно материала.',
        },
      },
    },
    english: {
      title: 'Английские шашки',
      items: {
        setup: {
          title: 'Расстановка',
          body: 'У каждого игрока 12 шашек на тёмных полях трёх ближних рядов доски 8×8. Первыми ходят чёрные.',
        },
        menMovement: {
          title: 'Простые',
          body: 'Простая шашка ходит на одно поле по диагонали вперёд на свободное тёмное поле.',
        },
        menCaptures: {
          title: 'Бой простой',
          body: 'Простая бьёт только вперёд: перепрыгивает соседнюю шашку соперника и приземляется на свободное поле за ней. Бой обязателен.',
        },
        kings: {
          title: 'Дамки',
          body: 'Шашка, достигшая последней горизонтали соперника, становится дамкой. Дамка ходит на одно поле по диагонали в любую сторону — вперёд или назад.',
        },
        kingCaptures: {
          title: 'Бой дамки',
          body: 'Дамка бьёт, перепрыгивая соседнюю шашку соперника — вперёд или назад — и приземляется на свободное поле сразу за ней.',
        },
        chain: {
          title: 'Серия боёв',
          body: 'Если с поля приземления возможен следующий бой, он продолжается в том же ходу. Простая, попавшая на дамочную горизонталь в середине серии, превращается в дамку, но серия на этом заканчивается.',
        },
        ending: {
          title: 'Окончание',
          body: 'Победа — взять все шашки соперника или лишить его ходов. Ничья объявляется после 40 ходов одних дамок без боя и без продвижения простых.',
        },
      },
    },
  },
  game: {
    banner: {
      turn: 'Ход — {{player}}',
      youWin: 'Вы выиграли!',
      youLose: 'Вы проиграли',
      whiteWins: 'Победили белые',
      blackWins: 'Победили чёрные',
      draw: 'Ничья',
    },
    pingOpponent: 'Подтолкнуть соперника',
  },
  online: {
    create: {
      title: 'Создать комнату',
      codeLabel: 'Код комнаты',
      share: 'Поделитесь этим кодом с соперником',
      variantLabel: 'Играем в {{variant}}',
      create: 'Создать',
    },
    share: {
      copyCode: 'Скопировать код',
      copyLink: 'Скопировать ссылку',
      copied: 'Скопировано!',
    },
    identity: {
      verifiedName: '{{name}} ✓',
    },
    join: {
      title: 'Войти в комнату',
      codeLabel: 'Введите код комнаты',
      typeHint: 'Введите код из 4 символов',
      enterHint: 'Нажмите Enter, чтобы войти',
      submit: 'Войти',
      variantLabel: 'В комнате играют в {{variant}}',
      paste: 'Вставить',
    },
    status: {
      connecting: 'Соединение',
      creating: 'Создание комнаты',
      waitingForOpponent: 'Ожидание соперника',
      opponentJoined: 'Соперник присоединился',
      joining: 'Подключение',
      couldNotJoin: 'Не удалось войти',
      error: 'Ошибка соединения',
    },
    overlay: {
      opponentDisconnected: '{{name}} отключился',
      waitingForReconnection: 'Ждём переподключения {{countdown}}',
      reconnecting: 'Переподключение',
      restoringGame: 'Восстановление игры {{countdown}}',
      connectionLost: 'Связь потеряна',
      gameEnded: 'Игра завершена',
      rematchOffered: 'Предложен реванш',
      waitingForOpponent: 'Ожидание {{name}}',
      rematchRequested: '{{name}} предлагает реванш',
      rematchDeclined: '{{name}} отказался от реванша',
      gameOverWin: 'Вы выиграли!',
      gameOverLoss: 'Вы проиграли',
      gameOverDraw: 'Ничья',
      gameOverPrompt: 'Сыграть ещё?',
      buttons: {
        leave: 'Выйти',
        rematch: 'Реванш',
        returnToMenu: 'Меню',
        cancel: 'Отмена',
        accept: 'Принять',
        decline: 'Отклонить',
      },
    },
    resumeModal: {
      reconnectingTitle: 'Переподключение…',
      reconnectingBody: 'Возвращаемся в игру…',
      seatTakenTitle: 'Место занято',
      seatTakenBody: 'Это место принадлежит другому аккаунту. Войдите под тем аккаунтом или начните новую игру.',
      roomGoneTitle: 'Стол закрыт',
      roomGoneBody: 'Эта партия завершена — стол закрыт.',
      roomFullTitle: 'Комната заполнена',
      roomFullBody: 'Все места за этим столом заняты, и ни одно из них не ваше.',
      anonymousTitle: 'Не можем подтвердить, что это место ваше',
      anonymousBody: 'В этом браузере нет записи об этой игре. Войдите в аккаунт перед следующей онлайн-игрой, и ваше место будет доступно с любого устройства.',
      unreachableTitle: 'Не удалось связаться с сервером',
      unreachableBody: 'Сервер не отвечает. Проверьте соединение и попробуйте снова.',
      signIn: 'Войти',
      viewSaved: 'Посмотреть сохранённую позицию',
      retry: 'Повторить',
      discard: 'Удалить',
    },
  },
  historyList: {
    title: 'История партий',
    empty: 'Сохранённых партий пока нет — сыграйте, чтобы начать список.',
    vsTemplate: '{{white}} — {{black}}',
    winnerTemplate: 'Победа {{name}}',
    draw: 'Ничья',
    unfinished: 'Не завершена',
    movesCount: '{{count}} ходов',
    deleteAria: 'Удалить партию',
    deleteConfirm: 'Удалить эту сохранённую партию?',
    downloadAria: 'Скачать журнал партии',
    modes: {
      ai: 'Против бота',
      local: 'Локально',
      online: 'По сети',
    },
    accountSection: {
      title: 'Ваш аккаунт',
      loading: 'Загрузка…',
      empty: 'Пока нет онлайн-партий.',
      statsLine: '{{wins}}В – {{losses}}П – {{draws}}Н ({{played}} сыграно)',
    },
    deviceSection: {
      title: 'На этом устройстве',
    },
  },
  replay: {
    controls: {
      first: 'В начало',
      previous: 'Назад',
      play: 'Играть',
      pause: 'Пауза',
      next: 'Вперёд',
      last: 'В конец',
      speed: 'Скорость',
      backToHistory: 'К списку',
      backToMenu: 'В меню',
    },
  },
  pwa: {
    updateAvailable: {
      title: 'Доступно обновление',
      body: 'Готова новая версия игры. Обновите страницу, чтобы загрузить её.',
      refresh: 'Обновить',
      later: 'Позже',
    },
  },
};
